import { businessData } from '../config/businessData'
import type { CartBox } from '../order/cartStorage'

export type CartValidationIssueCode =
  | 'ordering-paused'
  | 'delivery-unavailable'
  | 'pack-unavailable'
  | 'pack-price-changed'
  | 'product-sold-out'
  | 'product-unavailable'

export type CartValidationIssue = {
  boxId: string | null
  code: CartValidationIssueCode
  productId?: string
  productName?: string
}

export function validateCartBoxSnapshot(box: CartBox): CartValidationIssue[] {
  const issues: CartValidationIssue[] = []
  const currentPack = businessData.packs.find((pack) => pack.quantity === box.quantity)

  if (!currentPack?.available) {
    issues.push({ boxId: box.id, code: 'pack-unavailable' })
  } else if (currentPack.price !== box.price) {
    issues.push({ boxId: box.id, code: 'pack-price-changed' })
  }

  for (const selection of box.selections) {
    const product = businessData.products.find((item) => item.id === selection.productId)
    if (product?.availability === 'sold-out') {
      issues.push({
        boxId: box.id,
        code: 'product-sold-out',
        productId: selection.productId,
        productName: product.name,
      })
    } else if (!product
      || !product.weeklyMenuIncluded
      || !product.orderable
      || product.availability !== 'available') {
      issues.push({
        boxId: box.id,
        code: 'product-unavailable',
        productId: selection.productId,
        productName: selection.productName,
      })
    }
  }

  return issues
}

export function validateCartSnapshots(boxes: readonly CartBox[]): CartValidationIssue[] {
  const operationalIssues: CartValidationIssue[] = []

  if (!businessData.ordering.enabled) {
    operationalIssues.push({ boxId: null, code: 'ordering-paused' })
  }

  if (!businessData.delivery.enabled) {
    operationalIssues.push({ boxId: null, code: 'delivery-unavailable' })
  }

  return [
    ...operationalIssues,
    ...boxes.flatMap(validateCartBoxSnapshot),
  ]
}
